module.exports = __webpack_public_path__ + "static/media/logo_corridaperfeita_azul.2c7cd010.png";